import { CommonModule, registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { ApplicationRef, DoBootstrap, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AufgabeModule } from './aufgabe/aufgabe.module';
import { MaterialModule } from './common/material/material.module';
import { WestnetzModule } from './common/westnetz/westnetz.module';
import { NetzbetreiberModule } from './netzbetreiber/netzbetreiber.module';
import { AuthGuard } from './service/auth/auth.guard';
import { SessionInterceptor } from './service/auth/session.interceptor';
import { UflaLandingpageComponent } from './ufla-landingpage/ufla-landingpage.component';
import { AnleitungenModule } from './anleitungen/anleitungen.module';
import { OAuth2AuthGuard } from './service/auth/oauth2.guard';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { GermanPaginatorIntl } from './common/material/german-paginator-intl';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { GermanDatepickerIntl } from './common/material/german-datepicker-intl';

registerLocaleData(localeDe);

const INTERCEPTORS = [
    SessionInterceptor,
];

const GUARDS = [
    AuthGuard,
    OAuth2AuthGuard,
];

@NgModule({
    declarations: [
        AppComponent,
        UflaLandingpageComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        MaterialModule,
        WestnetzModule,
        NetzbetreiberModule,
        AufgabeModule,
        AnleitungenModule,
        FormsModule,
        CommonModule,
    ],
    providers: [
        INTERCEPTORS,
        GUARDS,
        { provide: LOCALE_ID, useValue: 'de-DE' },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [
                MAT_DATE_LOCALE,
                MAT_MOMENT_DATE_ADAPTER_OPTIONS,
            ],
        },
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
        { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
        {
            provide: MAT_DIALOG_DEFAULT_OPTIONS,
            useValue: {
                hasBackdrop: true,
                ariaModal: true,
                restoreFocus: true,
                delayFocusTrap: true,
                autoFocus: 'first-tabbable',
            } as MatDialogConfig,
        },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                appearance: 'outline',
                floatLabel: 'always',
                subscriptSizing: 'dynamic',
            } as MatFormFieldDefaultOptions,
        },
        {
            provide: MatPaginatorIntl,
            useClass: GermanPaginatorIntl,
        },
        {
            provide: MatDatepickerIntl,
            useClass: GermanDatepickerIntl,
        },
    ],
})
export class AppModule implements DoBootstrap {

    ngDoBootstrap(appRef: ApplicationRef): void {
        console.log('Starting UFLA');
        appRef.bootstrap(AppComponent);
    }
}
